export const formatNumberForDisplay = (count: number, fractionDigits: number): string => {
  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: fractionDigits,
  })
    .format(count)
    .toLowerCase();
};

export const getDaysAgo = (fromDate: Date, toDate: Date) => {
  // Ensure both dates are Date objects
  const from = new Date(fromDate).getTime();
  const to = new Date(toDate).getTime();

  // Calculate the difference in milliseconds
  const diffInMs = to - from;

  // Convert milliseconds to days
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  return diffInDays;
};
